import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';
import { routes } from './app-routing.module';
import {TranslateModule, TranslateLoader} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LazyLoadImageModule, scrollPreset } from 'ng-lazyload-image'
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { NgxGoogleAnalyticsModule, NgxGoogleAnalyticsRouterModule } from 'ngx-google-analytics';

import { AppComponent } from './app.component';
import { BlogModule } from './blog/blog.module'
// import { ElementsModule } from './elements/elements.module'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { ScrollToModule } from 'ng2-scroll-to-el';
import { SharedModule } from './shared/shared.module'
import { PagesModule } from './pages/pages.module';
import { of } from 'rxjs';
import { environment } from 'src/environments/environment';

export function HttpLoaderFactory() {
  return {
    getTranslation: (lang: string) => {
      return of(require(`../assets/i18n/${lang}.json`))
    }
  } as TranslateLoader;
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    BlogModule,
    HttpClientModule,
    CarouselModule,
    ScrollToModule,
    SharedModule,
    PagesModule,
    RouterModule.forRoot(routes, { useHash: false, anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled', relativeLinkResolution: 'legacy' }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
      }
    }),
    LazyLoadImageModule.forRoot({
      preset: scrollPreset
    }),
    SweetAlert2Module.forRoot(),
    NgxGoogleAnalyticsModule.forRoot(environment.googleAnalyticsTrackingCode),
    NgxGoogleAnalyticsRouterModule.forRoot()
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
